import { BBreadcrumb } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBBreadcrumb = createEgBootstrapProxy(
  "EgBBreadcrumb",
  BBreadcrumb
);
